export default __webpack_public_path__ + "static/media/Facebook.2ee50660.svg";